import {
  DistributeCenter,
  DistributeCenterSmall,
  DistributeFullWidth,
  DistributeFullWidthSmall,
  DistributeVertically,
  DistributeVerticallySmall,
  SizeAndRatio,
  SizeAndRatioSmall
} from "@wix/wix-ui-icons-common";
import {
  SIZE_DROPDOWN_OPTION_CONTENT,
  SIZE_DROPDOWN_OPTION_FULL_WIDTH,
  SIZE_DROPDOWN_OPTION_ORIGINAL,
  SIZE_DROPDOWN_OPTION_SMALL
} from "../../data-hooks.js";
const NODE_SIZE_BUTTONS = {
  CONTENT: {
    text: "SizeContentButton_Tooltip",
    tooltip: "SizeContentButton_Tooltip",
    value: "CONTENT",
    icon: DistributeVertically,
    mobileIcon: DistributeVerticallySmall,
    wixelIcon: DistributeVertically,
    dataHook: SIZE_DROPDOWN_OPTION_CONTENT
  },
  SMALL: {
    text: "SizeSmallCenterButton_Tooltip",
    value: "SMALL",
    icon: DistributeCenter,
    mobileIcon: DistributeCenterSmall,
    wixelIcon: DistributeCenter,
    dataHook: SIZE_DROPDOWN_OPTION_SMALL
  },
  ORIGINAL: {
    text: "SizeOriginalButton_Tooltip",
    value: "ORIGINAL",
    icon: SizeAndRatio,
    mobileIcon: SizeAndRatioSmall,
    wixelIcon: SizeAndRatio,
    dataHook: SIZE_DROPDOWN_OPTION_ORIGINAL
  },
  FULL_WIDTH: {
    text: "SizeFullWidthButton_Tooltip",
    value: "FULL_WIDTH",
    icon: DistributeFullWidth,
    mobileIcon: DistributeFullWidthSmall,
    wixelIcon: DistributeFullWidth,
    dataHook: SIZE_DROPDOWN_OPTION_FULL_WIDTH
  }
};
const DEFAULT_OPTIONS = ["SMALL", "CONTENT", "FULL_WIDTH"];
export {
  DEFAULT_OPTIONS,
  NODE_SIZE_BUTTONS
};
//# sourceMappingURL=consts.js.map
